import { z } from "zod";

export const lenderSubmissionSchema = z.object({
  // Lender Information
  lenderName: z.string().min(2, "Lender name required").max(100),
  contactPerson: z.string().min(2, "Contact person required").max(100),
  email: z.string().email("Invalid email address").max(255),
  phone: z.string().min(10, "Phone must be at least 10 characters").max(20),
  
  // Loan Product Details
  productType: z.string().min(1, "Product type required"),
  loanAmount: z.string().min(1, "Loan amount required"),
  interestRate: z.string().min(1, "Interest rate required"),
  termMonths: z.string().min(1, "Loan term required"),
  
  // Deal Information
  dealId: z.string().min(3, "Deal ID required").max(50),
  industryFocus: z.string().min(1, "Industry focus required"),
  
  // Terms & Conditions
  conditions: z.string().min(10, "Please describe loan conditions (min 10 characters)").max(1000),
  collateralRequirements: z.string().max(500).optional(),
  personalGuarantee: z.boolean(),
  
  // Financial Requirements
  minimumDSCR: z.string().optional(),
  minimumCreditScore: z.string().optional(),
  maxLTV: z.string().optional(),
  
  // Additional Details
  processingTime: z.string().min(1, "Processing time required"),
  fees: z.string().max(500).optional(),
  specialFeatures: z.string().max(500).optional(),
  notes: z.string().max(1000).optional(),
  
  // NDA — Inline Non-Disclosure Agreement (legally bound to this submission)
  ndaAcknowledge: z.boolean().refine((val) => val === true, {
    message: "You must acknowledge and accept the NDA to submit an offer",
  }),
  ndaSignatureName: z.string().min(2, "Please type your full legal name as electronic signature").max(150),
  ndaSignatureTitle: z.string().min(2, "Please indicate your title / position").max(150),

  // Confirmations
  agreeToTerms: z.boolean().refine((val) => val === true, {
    message: "You must agree to the terms and conditions",
  }),
});

export type LenderSubmissionFormData = z.infer<typeof lenderSubmissionSchema>;
